import { Injectable } from '@angular/core';

import { HttpClient } from '../_services/global-http.service';
//import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import {Observable} from 'rxjs/Observable';

@Injectable()

export class TrackService {
  constructor (private http: HttpClient) {}

  data: any;

// add paramaters later?  May just want to get a subset of the vehicles available to the user
  getTrack1() {
    //console.log('/*-- TRACK ---------------*/');

    this.data = this.http.get('/api/track/');
    //console.log(this.data);
    //console.log('/*-- END TRACK -------------*/');
    return this.data;
  }

  getTrack() {
    //console.log('/*-- TRACK ---------------*/');

    this.data = this.http.get('/api/track/');
    //console.log(this.data);
    //console.log('/*-- END TRACK -------------*/');
    return this.data;
  }

  getTrackCollapsible() {
    //console.log('/*-- TRACK ---------------*/');

    this.data = this.http.get('/api/collapsible/track/');
    //console.log(this.data);
    //console.log('/*-- END TRACK -------------*/');
    return this.data;
  }

  getTrackVehicleGroup(group_id) {
    //console.log('/*-- TRACK ---------------*/');

    this.data = this.http.get('/api/expanded/track/?group_id=' + group_id);
    //console.log(this.data);
    //console.log('/*-- END TRACK -------------*/');
    return this.data;
  }

  getTrackVehicle(vehicle_id) {
    this.data = this.http.get('/api/expanded/track/vehicle/' + vehicle_id + '/');
    //console.log(this.data);
    //console.log('/*-- END TRACK -------------*/');
    return this.data;
  }

  timer = Observable.timer(0, 30000); // timer every 20seconds
  // Observable timer for polling the Track API
  getTrackPolling = () => {
    return this.timer
      .flatMap((i) => this.http.get("/api/track/"))
  }


}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/track.service.ts